namespace AgerLMS.Administration {
    export interface CheckUserSMSResponse extends Serenity.ServiceResponse {
        Guid?: string;
        Message?: string;
    }
}
